import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'fixed top-0 right-0 left-0 z-23 flex h-[56px] items-center pr-2 pl-3 transition-all duration-300 md:h-30 md:justify-between md:px-10',
    logoWr: 'flex items-center',
    logoNaos: 'max-md:max-w-[120px]',
    logoEsthederm: 'max-md:ml-5 max-md:max-w-[89px]',
    divider: 'ml-5 h-5 w-px bg-black md:hidden',
    cart: 'relative flex w-[38px] justify-end max-md:w-full max-md:justify-end md:w-[178px]',
    cartCounter:
      'bg-blue-dark absolute top-[6px] right-1 flex min-w-5 items-center justify-center gap-[1px] rounded-full border-1 border-white px-1 text-center text-[10px] text-white',
    progress:
      'pointer-events-none absolute bottom-0 left-0 h-0 border-b-4 transition-[width] duration-150 ease-linear'
  },
  variants: {
    scrolled: {
      true: 'bg-white md:h-20',
      false: 'bg-transparent'
    },
    light: {
      true: '',
      false: ''
    }
  },
  compoundSlots: [
    {
      slots: ['logoNaos'],
      scrolled: true,
      class: 'md:h-8'
    },
    {
      slots: ['logoEsthederm'],
      scrolled: true,
      class: 'md:h-14'
    },
    {
      slots: ['divider'],
      light: true,
      scrolled: false,
      class: 'bg-white'
    }
  ],
  defaultVariants: {
    scrolled: false
  }
});
